<template>
  <modal v-if="isOpen" class-name="garantie-modal" @close="$emit('close')">
    <template #body>
      <h4>Herstellergarantie</h4>
        <p>
        Für unsere Online-Deals gilt häufig noch die Herstellergarantie3, da sich im Online-Kauf viele Neufahrzeuge mit Tageszulassung oder Vorführwagen befinden. Achten Sie auf die Beschreibung der Fahrzeuge.
        </p>
        <h4>Kostenloses PKW.de-Schutzpaket</h4>
        <p>
        Neben der Herstellergarantie (falls vorhanden), verspricht Ihnen PKW.de ein zusätzliches Schutzpaket für Fahrzeuge, die Sie über den Online-Kauf bestellen. Das kostenlose PKW.de-Schutzpaket läuft 12 Monate ab Ende der Herstellergarantie.
        </p>
        <h4>Schutzpaket-Upgrade</h4>

        <p>
        In unserem Online-Kauf können Sie neben dem kostenlosen PKW.de-Basic-Schutz weitere Schutzpakete buchen. Wählen Sie zwischen folgenden Paketen:</p>
        <ul class="styled-list">
          <li>Klassik-Schutz: 150€/12 Monate ab Lieferdatum</li>
          <li>Premium-Schutz: 270€/12 Monate ab Lieferdatum</li>
          <li>Premium-Plus-Schutz: 680€/12 Monate ab Lieferdatum</li>
        </ul>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
<style lang="scss">
    .garantie-modal {
        p {
            font-family: "Asap", sans-serif;
            color: #3a3a3a;
            font-size: 16px;
            font-weight: normal;
            line-height: 21px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/GarantieModal.vue